module.exports = __webpack_public_path__ + "/bundle/asset/U2_05-97b2cf664532c1a29ed0c9e07a68dac1.gif";